import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { ClassNameMap } from '@mui/styles';

import { TableFilter } from '../../Table.types';

type MultiSelectFilterControlProps = {
  filter: TableFilter;
  activeFilters: Record<string, string>;
  classes: ClassNameMap;
  onFilterChange: (condition: string, value: any) => any;
};

export const MultiSelectFilterControl = ({
  filter,
  activeFilters,
  classes,
  onFilterChange,
}: MultiSelectFilterControlProps) => {
  const conditionKey = filter.conditions[0]?.key || 'in';
  const currentValue = activeFilters[conditionKey] || '';
  const selectedValues = currentValue ? currentValue.split(',') : [];

  const handleCheckboxChange = (value: string, checked: boolean) => {
    let newSelectedValues: string[];

    if (checked) {
      newSelectedValues = [...selectedValues, value];
    } else {
      newSelectedValues = selectedValues.filter(v => v !== value);
    }

    const newValue = newSelectedValues.join(',');
    onFilterChange(conditionKey, newValue);
  };

  return (
    <Box display="flex" flexDirection="column" className={classes.multiselectContainer}>
      {filter.values?.map((value, index) => (
        <FormControlLabel
          key={`multiselect-${index}-${value}`}
          control={
            <Checkbox
              data-testid={`multiselect-checkbox-${value}`}
              checked={selectedValues.includes(String(value))}
              onChange={e => handleCheckboxChange(String(value), e.target.checked)}
              color="primary"
              size="small"
            />
          }
          label={String(value)}
        />
      ))}
    </Box>
  );
};
